import React from "react";
import PropTypes from "prop-types";
import "./css/modalContent.css";

const ModalContent = ({ image, title, publisher, country }) => {
  return (
    <div className="d-flex justify-content-center">
      <div className=" text-center">
        <div className="book-cover-wrapper d-flex justify-content-center align-items-center">
          <img
            src={image}
            alt={title}
            className="size-images-modal-children-hv"
            draggable="false"
          />
        </div>

        <div className="mt-3 d-flex flex-column">
          <p className="color-text-gris-modal-character-20-hv mb-1">{title}</p>
          <p className="mb-0 color-text-body-children-modal-hv">{publisher}</p>
          <p className="mb-0 color-text-body-children-modal-hv">{country}</p>
        </div>
      </div>
    </div>
  );
};

ModalContent.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  publisher: PropTypes.string,
  country: PropTypes.string,
};

export default ModalContent;
